import React, { useEffect, useState } from 'react';
import { Menu } from '../../ui/layout/Menu';
import useApi from '../../hooks/useApi';
import { userState } from '../../store';
import { useSnapshot } from 'valtio';
import { FooterCmp } from '../../ui/layout/Footer';
import { ApiError, Team } from '../../@backend';
import { PageHeader } from '../../ui/ds/PageHeader';
import { Card } from '../../ui/ds/Card';
import { Btn } from '../../ui/ds/Btn';
import { Badge } from '../../ui/ds/Badge';

export const BonusTip = () => {
    const userSnap = useSnapshot(userState);
    const { backend } = useApi(true);
    const [teams, setTeams]                 = useState<Team[]>([]);
    const [selectedTeam, setSelectedTeam]   = useState<number>(userSnap.userProfile?.bonusQuestionAnswer ?? 0);
    const [errorMessage, setErrorMessage]   = useState<string | null>(null);
    const [successMessage, setSuccessMessage] = useState<string | null>(null);

    useEffect(() => {
        if (userSnap.isLoggedIn) {
            backend.teams.teamsControllerGetAllTeams(Number(process.env.REACT_APP_ACTIVE_TOURNAMENT_ID))
                .then((res: Team[]) => setTeams(res));
        }
    }, [userSnap.isLoggedIn]);

    if (!userSnap.isLoggedIn) {
        return (
            <><Menu /><div className="max-w-md mx-auto px-4 py-16 text-center"><p className="tb-h2 text-text-primary">Je vyžadováno přihlášení</p></div></>
        );
    }

    const sendBonusQuestion = () => {
        setSuccessMessage(null);
        setErrorMessage(null);
        const userId = userSnap.userProfile?.id;
        if (!userId) {
            setErrorMessage('Chybí ID přihlášeného uživatele');
            return;
        }

        backend.user.userControllerAnswerBonusQuestion(userId, { answer: Number(selectedTeam) })
            .then(() => {
                setSuccessMessage('Odpověď byla úspěšně odeslána');
                userState.userProfile.bonusQuestionAnswer = Number(selectedTeam);
            })
            .catch((e: ApiError) => {
                setErrorMessage(e.body?.error?.message ?? 'Chyba při ukládání');
            });
    };

    const alreadyAnswered = !!userSnap.userProfile?.bonusQuestionAnswer;

    return (
        <>
            <Menu />
            <PageHeader
                title="Bonusová otázka"
                subtitle="Správná odpověď vám přinese +50 bodů"
                variant="orange"
            />

            <div className="max-w-2xl mx-auto px-4 md:px-8 py-6 flex flex-col gap-4">
                {/* Info banner */}
                <div className="flex gap-3 bg-brand-orange/10 border border-brand-orange/20 rounded-content px-4 py-4">
                    <span className="text-[20px] flex-shrink-0">🎯</span>
                    <div>
                        <p className="tb-h4 text-text-primary mb-1">O bonusové otázce</p>
                        <p className="tb-body text-text-muted">
                            Každý hráč má možnost odpovědět na bonusovou otázku a získat tak bonusové body (+50 bodů).
                            Bonusové body se započítávají do celkového pořadí a mohou zamíchat žebříčkem.
                        </p>
                    </div>
                </div>

                <Card>
                    <h2 className="tb-title text-text-primary mb-2">
                        Kdo vyhraje <span className="text-brand-orange">MS 2025 v hokeji</span>?
                    </h2>

                    {/* Feedback */}
                    {errorMessage && (
                        <div className="flex items-center gap-3 bg-semantic-danger/10 border border-semantic-danger/20 rounded-content px-4 py-3 mb-4">
                            <Badge variant="danger">Chyba</Badge>
                            <span className="tb-body text-semantic-danger">{errorMessage}</span>
                        </div>
                    )}
                    {successMessage && (
                        <div className="flex items-center gap-3 bg-semantic-success/10 border border-semantic-success/20 rounded-content px-4 py-3 mb-4">
                            <Badge variant="success">Uloženo</Badge>
                            <span className="tb-body text-semantic-success">{successMessage}</span>
                        </div>
                    )}

                    {/* Team grid */}
                    <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 mb-5">
                        {teams.map(team => {
                            const isSelected = selectedTeam === team.id;
                            return (
                                <button
                                    key={team.id}
                                    onClick={() => setSelectedTeam(team.id)}
                                    className={[
                                        'flex items-center gap-2 px-3 py-2.5 rounded-card border-2 text-left transition-all duration-150 font-nunito text-[14px] font-semibold',
                                        isSelected
                                            ? 'border-brand-orange bg-brand-orange/10 text-brand-orange'
                                            : 'border-border-neutral text-text-primary hover:border-brand-orange/40 hover:bg-brand-orange/5',
                                    ].join(' ')}
                                >
                                    <span className="text-[18px]">{team.nameCountry}</span>
                                </button>
                            );
                        })}
                    </div>

                    <Btn
                        variant="orange"
                        size="md"
                        fullWidth
                        onClick={sendBonusQuestion}
                        disabled={!selectedTeam}
                    >
                        {alreadyAnswered ? 'Změnit odpověď' : 'Odeslat odpověď'}
                    </Btn>
                </Card>
            </div>

            <FooterCmp />
        </>
    );
};
